module.exports = __webpack_public_path__ + "static/img/gptModel32.e32e895c.png";